import React from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import SideBarContentHolder from "../../Reusable/SideBar/SideBarContentHolder.js";
import ShareSideComponent from "../../Reusable/SideBar/Share/ShareSideComponent.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import useSuspendedUser from "hooks/useSuspendedUser.ts";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";

const ShareActionComponent = ({
  itemId,
  folderId,
  lightBox,
  iconName,
  tooltipDisabled,
  withTitle,
}) => {
  const { setSideBar } = useSideBar();
  const { getTextByKey } = useContent();
  const { isUserSuspended } = useSuspendedUser();
  const { addToast } = useToasts();

  const handleClick = () => {
    if (isUserSuspended) {
      addToast(getTextByKey("suspended-user-toast"), {
        appearance: "error",
      });
      return;
    }

    setSideBar(
      <SideBarContentHolder
        headerName={getTextByKey("sidebar-share-header")}
        headerIcon={"share-solid"}
      >
        <ShareSideComponent
          itemId={itemId}
          folderId={folderId}
          lightBox={lightBox}
        >
          {itemId ? null : "its global"}
        </ShareSideComponent>
      </SideBarContentHolder>,
      itemId,
      lightBox
    );
  };

  const toolipId = `shareActionIcon${
    itemId ? "-" + itemId : folderId ? "-" + folderId : ""
  }`;

  return (
    <section onClick={handleClick}>
      {!tooltipDisabled && !withTitle ? (
        <Tooltip id={toolipId} tooltipTextKey="share-icon-tooltip-text" top>
          <Icon name={iconName || "share"} gray clickable />
        </Tooltip>
      ) : (
        <Icon name={iconName || "share"} onClick={handleClick} gray clickable />
      )}
      {withTitle && getTextByKey("share-icon-tooltip-text")}
    </section>
  );
};

export default ShareActionComponent;
